module.exports = __webpack_public_path__ + "img/background.7c6defb0.jpg";